<template>
  <a-modal :open="open" @cancel="closeForm" class="modal-no-padding">
    <div class="modal-no-padding__header">
      <h2>Объединение групп ({{ selectedGroups.length }})</h2>
    </div>
    <a-divider style="margin: 16px 0" />
    <div class="modal-no-padding__body">
      <span>Название новой группы</span>
      <a-input v-model:value="groupForm.name" />
      <span v-if="statusError.groupName">
        Ввведите название группы
      </span>
      <div class="delete-checkbox-wrapper">
        <a-checkbox v-model:checked="groupForm.delete_after_merge">Удалить группы после объединения</a-checkbox>
      </div>
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
          <a-row justify="end" :gutter="8">
            <a-col>
              <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
            </a-col>
            <a-col>
              <a-button class="primary-button" :loading="modalActionLoading" @click="handleGroupMerge">Объединить</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {message} from "ant-design-vue";
import {useStore} from "vuex";
import {reactive, ref} from "@vue/runtime-core";

export default {
  props: {
    open: Boolean,
    selectedGroups: Array,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);

    const statusError = reactive({
      groupName: false,
    });

    const groupForm = reactive({
      name: null,
      groups: props.selectedGroups,
      users: [],
      delete_after_merge: false,
    });

    const handleGroupMerge = () => {
      if (!groupForm.name) {
        statusError.groupName = true;
        modalActionLoading.value = false;
        return;
      } else {
        statusError.groupName = false;
      }

      modalActionLoading.value = true;

      store.dispatch('group/mergeGroups', {...groupForm}).then(() => {
        message.success('Группы объединены');
        context.emit('submitted');
      }).finally(() => {
        modalActionLoading.value = false;
      });
    }

    const closeForm = () => {
      context.emit('close');
    }

    return {
      modalActionLoading,
      closeForm,
      handleGroupMerge,
      groupForm,
      statusError
    }
  }
}
</script>

<style scoped lang="scss">
  .delete-checkbox-wrapper {
    margin-top: 16px;
  }
</style>